import { useAppUserAccess } from "global/cnr/contexts/useHelpers/useAppUserAccess";
import _ from "lodash";
import { useContext, useEffect, useState } from 'react';
import { SettingParentContext } from "../../cnr/contexts/SettingParentContext";
import { getUpdateConfirmation } from "../../cnr/reducers/reducerHelpers/dispatchProps";
import { DimmerWrap } from '../../components/alerts/DimmerWrap';
import UiSaveButtons from '../../components/buttons/UiSaveButtons';
import JsonViewer from '../../components/viewers/JsonViewer';
import { appIconTypes } from "../../enums/appIconTypes";
import GenericButton from "../../genericControls/GenericButton";
import Wrapper, { wrapperTypes } from '../../wrappers/Wrapper';
import { useBaseSettingsData } from "global/cnr/contexts/useHelpers/useBaseSettingsData";

const allowUpdate = true
const dimmerCaption = 'Fetching'
const WAIT_INTERVAL = 2000

const BaseSettingsViewer = () => {

  // settingsParentContext
  const settingsParentContext = useContext(SettingParentContext)
  const { states, handlers, settings } = settingsParentContext ?? {}
  const { baseSettings_state } = states ?? {}
  const { baseSettings_handlers } = handlers ?? {}
  const { homeSettings } = settings ?? {}
  const { global: homeSettings_global } = homeSettings ?? {}
  const { logging } = homeSettings_global ?? {}
  const appUserAccess = useAppUserAccess()

  const { baseSettings, baseSettings_functions } = baseSettings_state ?? {}
  const { adjustedPermissions } = baseSettings ?? {}
  const { adjustedPermissions: adjustedPermissions_functions } = baseSettings_functions ?? {}

  const { getAppSettingsFromFunctions, handleUpdateAppSettings } = useBaseSettingsData()

  const [question, setQuestion] = useState()
  const [areEqual, setAreEqual] = useState(true)
  const [confirmation, setConfirmation] = useState()
  const [updating, setUpdating] = useState()

  useEffect(() => {
    if (confirmation) {
      const timer = setTimeout(() => {
        setConfirmation()
        setUpdating()
      }, WAIT_INTERVAL);
      return () => clearTimeout(timer);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [confirmation]);

  useEffect(() => {
    getAppSettingsFromFunctions({ appUserAccess, logging, callback: baseSettings_handlers.handleSetFunctionsAppSettings })
    // baseSettings_handlers.handleGetAppSettingsFromFunctions(appUserAccess, logging)
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, []);

  useEffect(() => {
    if (baseSettings_functions && baseSettings) {
      console.log('baseSettings_functions', baseSettings_functions)
      console.log('baseSettings', baseSettings)
      setAreEqual(_.isEqual(baseSettings_functions, baseSettings))
      // checkSettingsConsole()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [baseSettings_functions, baseSettings]);

  const btnProps = { inverted: true, color: allowUpdate && !areEqual ? 'blue' : 'olive' }

  const handleSetConfirmation = (sr) => setConfirmation(getUpdateConfirmation(sr))

  const handleSave = () => {
    setUpdating(true)
    const _baseSettings_functions = _.cloneDeep(baseSettings_functions)
    delete _baseSettings_functions.adjustedPermissions
    const aua = appUserAccess ? { uid: appUserAccess.uid, displayName: appUserAccess.displayName } : { uid: 0, displayName: 'Unknown' }
    handleUpdateAppSettings({ settings: _baseSettings_functions, aua })
    // baseSettings_handlers.handleUpdateAppSettings(_baseSettings_functions, handleSetConfirmation)
  }

  const handleSaveWithAdjusted = () => {
    setUpdating(true)
    const aua = appUserAccess ? { uid: appUserAccess.uid, displayName: appUserAccess.displayName } : { uid: 0, displayName: 'Unknown' }
    handleUpdateAppSettings({ settings: baseSettings_functions, aua })
    // baseSettings_handlers.handleUpdateAppSettings(baseSettings_functions, handleSetConfirmation)
  }

  const gb = (key, caption, icon, onClick, clickOptions, opts, noE) => <GenericButton gbProps={{ key, caption, icon, onClick, clickOptions, opts, noE }} />

  const handleQuestion = () => setQuestion(true)
  const button_saveBase = () => gb('btn-save', 'Update Base Settings', 'save', handleQuestion, null, { ...btnProps })

  const viewer_baseSettingsConfirm = () => <JsonViewer keyy={'jvr-1'} json={adjustedPermissions_functions} name={'All Settings - Functions'} />
  const viewer_baseSettings = () => <JsonViewer keyy={'jvr-1'} json={baseSettings_functions} name={'Base Settings'} showButtons={{ 'copy': true }} saveButton={button_saveBase()} />
  const viewer_appSettings = () => <JsonViewer keyy={'jvr-2'} json={adjustedPermissions} name={'App Settings'} showButtons={{ 'copy': true }} />

  const content = () => <div className={'split-container-half'}>
    <Wrapper
      header={'Base Settings'}
      content={adjustedPermissions ? viewer_appSettings() : <DimmerWrap caption={dimmerCaption} />}
      wrapperType={wrapperTypes.paddedHeader}
    />
    <Wrapper
      header={'Fuctions Base Settings'}
      content={adjustedPermissions_functions ? viewer_baseSettings() : <DimmerWrap caption={dimmerCaption} />}
      wrapperType={wrapperTypes.paddedHeader}
    />
    {/* {baseSettings_functions ? viewer_baseSettings() : <DimmerWrap caption={dimmerCaption} />} */}

  </div>

  const saveButtons = () => {
    const btns = [
      { caption: 'Cancel', oc: setQuestion, color: 'blue', icon: appIconTypes.cancel },
      { caption: 'Save', oc: handleSave, color: 'green', icon: appIconTypes.save },
      { caption: 'Save with Adjusted', oc: handleSaveWithAdjusted, color: 'green', icon: appIconTypes.save },
    ]
    return <UiSaveButtons others={btns} />
  }

  const wrapper_confirm = () => <Wrapper
    content={viewer_baseSettingsConfirm()}
    footer={saveButtons()}
    wrapperType={wrapperTypes.padded}
    updating={updating}
    confirmation={confirmation}
  />

  console.log('question', question)

  return question ? wrapper_confirm() : content()
}

export default BaseSettingsViewer